module.exports = __webpack_public_path__ + "static/img/certificate07.a3ed08c5.jpeg";